import React from 'react';
import { Link } from 'react-router-dom';

function Breadcrumb({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <nav className="text-sm text-gray-500 m-4" aria-label="Breadcrumb">
      <ol className="list-reset flex">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center">
              {!isLast ? (
                <>
                  <Link to={item.to} className="text-blue-600 hover:underline">
                    {item.label}
                  </Link>
                  <span className="mx-2">/</span>
                </>
              ) : (
                <span className="text-gray-700 font-semibold">{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
